/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { put } from 'redux-saga/effects';

import { APP_AUTH_ERROR_SAGA, showAppError } from '../reducers/app';
import { t } from '../locales/i18n';

function* handleAuthError() {
  // Switches the queue page to its "authentication error" screen. Nothing sent
  // this before, so a wrong secret showed "no queue found — check your
  // internet connection" under the banner.
  yield put({ type: 'web-socket/auth-error/cbx' });
  yield put(showAppError(t('errors.auth.invalidCredentials'), 15));
  const url = window.location.pathname;
  if (!url.match(/\/settings/i)) {
    console.error('Redirect to /settings');
    //window.location.href = appSettingsPath(action.payload.deviceUUID);
  }
}

export function* authErrorSaga() {
  yield takeLatest(APP_AUTH_ERROR_SAGA, handleAuthError);
}
